import {http} from '../core/http';
import type {UpdateFileMetaParams} from '../types/file';

export const fileService = {
  updateFileMeta(params: UpdateFileMetaParams) {
    return http.post('/uss/update_file', params);
  },

  reparseFile(params: { file_id: number | string }) {
    return http.post('/uss/reparse_file', params);
  },

  updateFolderPermission(params: { id: number | string; visibility: 'edit' | 'read' }) {
    return http.post('/uss/set_directory_visibility', params);
  },
};